export default {
  // 標題
  title: "提示",

  // 提示信息
  trialExpiredMessage:
    "尊敬的用戶您好，您的試用版試用次數已經使用完了，如需繼續使用請聯繫客服購買付費版。",

  // 客服標籤
  wechatCustomerService: "微信客服",
};
